import React, { useEffect, useRef } from "react";
import { BarController, BarElement, CategoryScale, Chart as ChartJs, Colors, Filler, Legend, LinearScale, LineController, LineElement, PointElement, SubTitle, Title as ChartJsTitle, Tooltip, } from "chart.js";
import { ElementChartLoader } from "./Loaders/ElementChartLoader";
import { Icon, IconsContext } from "@hydrosoft/components";
import { onDownloadChartClick, onDownloadDataClick, onResetZoomClick, } from "@hydrosoft/chart";
const Chart = (props) => {
    const canvasRef = useRef();
    const chartRef = useRef();
    const chartLoader = new ElementChartLoader(props.element);
    const renderChart = () => {
        if (canvasRef.current === undefined)
            return;
        ChartJs.register(Colors, BarElement, CategoryScale, LinearScale, Legend, ChartJsTitle, SubTitle, Tooltip, BarController, LineController, BarElement, LineElement, PointElement, Filler);
        chartRef.current = new ChartJs(canvasRef.current, chartLoader.getConfig());
    };
    const destroyChart = () => {
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    useEffect(() => {
        renderChart();
        return () => destroyChart();
    }, []);
    const settings = chartLoader.getSettings();
    return (React.createElement("div", { className: "relative" },
        React.createElement("div", { className: "absolute right-0" },
            React.createElement(IconsContext.Provider, { value: {
                    path: "../images/chart-icons.svg",
                    size: "1.2rem",
                } },
                React.createElement("div", { className: "flex space-x-2" },
                    settings.zoom ? (React.createElement("a", { className: "cursor-pointer", onClick: () => {
                            onResetZoomClick(chartRef.current);
                        } },
                        React.createElement(Icon, { name: "zoom" }))) : (React.createElement(React.Fragment, null)),
                    settings.download ? (React.createElement(React.Fragment, null,
                        React.createElement("a", { className: "cursor-pointer", onClick: () => {
                                onDownloadDataClick(chartRef.current, "chart");
                            } },
                            React.createElement(Icon, { name: "data" })),
                        React.createElement("a", { className: "cursor-pointer", onClick: () => {
                                onDownloadChartClick(chartRef.current, "chart");
                            } },
                            React.createElement(Icon, { name: "chart" })))) : (React.createElement(React.Fragment, null))))),
        React.createElement("canvas", { ref: canvasRef, role: "img" })));
};
Chart.defaultProps = {};
export default Chart;
//# sourceMappingURL=Chart.js.map